// extracted by mini-css-extract-plugin
export var optionGrid = "_al-7";
export var optionList = "_al-6";
export var questionsBlock = "_al-9";
export var spacer = "_al-5";
export var stepCenteredContent = "_al-3";
export var stepInner = "_al-0";
export var stepInnerFullWidth = "_al-1";
export var stepInnerLockScroll = "_al-2";
export var stepTransitionFrame = "_al-4";
export var welcomeBlock = "_al-8";